import {CreateInstance} from './config'
const CompanyFunctionAPI = CreateInstance('company_function')
export default CompanyFunctionAPI
